// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"6d81c0c9","453":"b21437c2","518":"c5e18455","732":"a591f1f7","825":"1a6a2c1a","843":"55777c10"}[chunkId] + ".chunk.js";
};